import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface PartDetailsHeaderProps {
  isSupabaseConnected: boolean | null;
}

const PartDetailsHeader = ({ isSupabaseConnected }: PartDetailsHeaderProps) => {
  return (
    <div>
      {/* Hide the connection error alert */}
    </div>
  );
};

export default PartDetailsHeader;
